module.exports = __webpack_public_path__ + "static/img/GettyImages-637232994_600x450.8d568f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/GettyImages-637232994_600x450.jpg
// module id = Mfd5
// module chunks = 0